const PermissionNames = {
    ReadOnlyView: 'ReadOnlyView',
    ManageOutage: 'ManageOutage',
    Prioritize: 'Prioritize',
    GenerateRbs: 'GenerateRbs',
}

export default PermissionNames;
